import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyDebt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9726:61536)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M46.2 29.1926C46.2 32.3999 43.5999 35 40.3925 35L19.8074 35C16.6 35 13.9999 32.3999 13.9999 29.1926L14 5.80741C14 2.60007 16.6 1.7953e-06 19.8074 2.05713e-06L40.3926 3.73756e-06C43.5999 3.99939e-06 46.2 2.60007 46.2 5.80741L46.2 29.1926Z",
				fill: "#FFDFA2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.3258 54.95L7.67398 54.95C7.10839 54.95 6.6499 54.4915 6.6499 53.9259L6.6499 37.0741C6.6499 36.5085 7.1084 36.05 7.67398 36.05L13.3258 36.05C13.8914 36.05 14.3499 36.5085 14.3499 37.0741L14.3499 53.9259C14.3499 54.4915 13.8914 54.95 13.3258 54.95Z",
				stroke: "#031839",
				strokeWidth: 2.1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.1259 54.95L24.474 54.95C23.9084 54.95 23.4499 54.4915 23.4499 53.9259L23.4499 31.4741C23.4499 30.9085 23.9084 30.45 24.474 30.45L30.1259 30.45C30.6915 30.45 31.15 30.9085 31.15 31.4741L31.15 53.9259C31.15 54.4915 30.6915 54.95 30.1259 54.95Z",
				stroke: "#031839",
				strokeWidth: 2.1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.9259 54.95L41.2741 54.95C40.7085 54.95 40.25 54.4915 40.25 53.9259L40.25 20.2741C40.25 19.7085 40.7085 19.25 41.2741 19.25L46.9259 19.25C47.4915 19.25 47.95 19.7085 47.95 20.2741L47.95 53.9259C47.95 54.4915 47.4915 54.95 46.9259 54.95Z",
				stroke: "#031839",
				strokeWidth: 2.1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.79854 29.0366C1.79854 29.0366 16.3805 25.011 22.7994 20.8902C29.8259 16.3794 33.7425 12.3089 36.2277 6.93406M36.2277 6.93406L29.1778 7.86248M36.2277 6.93406L37.4204 13.6224",
				stroke: "#031839",
				strokeWidth: 2.1,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9726:61536",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 56,
			height: 56,
			fill: "white"
		})
	}) })]
});
export default SvgMyDebt;
